import * as React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import { ReplyScrollStore, ReplyScrollStoreContext } from '../../utils/replyScrollContext';
import { useApplicationContext } from '../../utils/applicationContext';
import { currentOpenChatIDSelector } from '../../selectors';

export const ReplyScrollProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const { getState } = useStore();
  const appContext = useApplicationContext();
  const chatId = useSelector(currentOpenChatIDSelector) || '';

  const store = React.useMemo(
    () =>
      new ReplyScrollStore({
        chatId,
        dispatchAppStore: dispatch,
        getAppState: getState,
        appContext,
      }),
    [chatId, dispatch, getState, appContext],
  );

  React.useEffect(() => {
    return () => {
      store.cancelHistoryLoading();
    };
  }, [store]);

  return <ReplyScrollStoreContext.Provider value={store}>{children}</ReplyScrollStoreContext.Provider>;
};
